"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Coupled = function Coupled(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "10",
    viewBox: "0 0 10 10",
    width: "10",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m6.28 4.08-.36-.36a2.07 2.07 0 0 0 -2.92 0l-2.39 2.38a2.07 2.07 0 0 0 0 2.9l.39.39a2 2 0 0 0 1.44.61 2.06 2.06 0 0 0 1.46-.61l1.1-1.12a.52.52 0 0 0 0-.73.51.51 0 0 0 -.74 0l-1.09 1.12a1.07 1.07 0 0 1 -1.47 0l-.36-.36a1 1 0 0 1 0-1.47l2.38-2.38a1.06 1.06 0 0 1 1.46 0l.37.37a.52.52 0 0 0 .73 0 .53.53 0 0 0 0-.74z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m9.39 1-.39-.39a2 2 0 0 0 -1.44-.61 2.06 2.06 0 0 0 -1.46.61l-1 1a.53.53 0 0 0 0 .74.52.52 0 0 0 .73 0l1-1a1.07 1.07 0 0 1 1.47 0l.36.36a1 1 0 0 1 0 1.47l-2.38 2.37a1.06 1.06 0 0 1 -1.46 0 .52.52 0 0 0 -.73 0 .51.51 0 0 0 0 .73 2.07 2.07 0 0 0 2.91 0l2.39-2.38a2.07 2.07 0 0 0 0-2.9z"
  }));
};

var _default = Coupled;
exports["default"] = _default;